import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { Department } from "./department";


export class WorkFlowDetails extends EntityDto implements IEntityDto {
  WorkFlowDetails_Id:string;
  WorkFlow_Id: string;
  Emp_Ref_Id: string;
  EmployeeName:string;
  WorkFlowOrder:Number;
  WorkFlowType_Id:number;
  IsActive: boolean;
  WorkFlowTypeName:string;
  MeetingType_id:string;
  TotalCount: number;
  EditBit: Number;
  Role_Id: number;
  Role_Name:string;
  constructor() {
    super();
    this.WorkFlow_Id = '00000000-0000-0000-0000-000000000000';
    this.Emp_Ref_Id = '';
    this.MeetingType_id='00000000-0000-0000-0000-000000000000';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.WorkFlowOrder = 0;
    this.WorkFlowType_Id = 0;
    this.IsActive = true;
    this.WorkFlowTypeName='';
    this.WorkFlowDetails_Id='00000000-0000-0000-0000-000000000000';
    this.EditBit=0;
    this.Role_Id = 0;
      this.Role_Name = "";
    this.EntityMetaData = [
      { FieldName: 'WorkFlowCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Code is required' },
      //{ FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' },
      { FieldName: 'WorkFlowName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Name is required' },
      {FieldName:'MeetingType_Id',FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Group is required'}
    ];
  }
}